<template>
  <div>
    <div class="editor"></div>
    <choose-photo
      :config="img.config"
      :field="img.field"
      :quote="2"
      ref="choose"
      @selectUrl="addImg"
    ></choose-photo>
  </div>
</template>

<script>
import ChoosePhoto from "../plugin/tms/components/field-type/choose-photo.vue";
import Quill from "quill";
import "./quill/quill.snow.css";
import "./quill/quill.core.css";
import "./quill/quill.bubble.css";
export default {
  name: "editor",
  props: {
    value: String,
  },
  components: {
    ChoosePhoto,
  },
  data() {
    return {
      quill: null,
      options: {
        theme: "snow",
        modules: {
          toolbar: {
            container: [
              ["bold", "italic", "underline", "strike"],
              ["blockquote", "code-block"],
              [{ header: 1 }, { header: 2 }],
              [{ list: "ordered" }, { list: "bullet" }],
              [{ script: "sub" }, { script: "super" }],
              [{ indent: "-1" }, { indent: "+1" }],
              [{ direction: "rtl" }],
              [{ size: ["small", false, "large", "huge"] }],
              [{ header: [1, 2, 3, 4, 5, 6, false] }],
              [{ color: [] }, { background: [] }],
              [{ font: [] }],
              [{ align: [] }],
              ["clean"],
              ["link", "image", "video"],
            ],
          },
        },
        placeholder: "点击输入 ...",
      },
      img: {
        config: {},
        field: {
          key: "name",
        },
      },
    };
  },
  mounted() {
    let dom = this.$el.querySelector(".editor");
    this.quill = new Quill(dom, this.options);
    this.quill.root.innerHTML = this.value || "";

    this.quill.getModule("toolbar").addHandler("image", this.showSelectImg);

    this.quill.on("text-change", () => {
      this.$emit("changeContent", this.quill.container.firstChild.innerHTML);
    });
  },
  methods: {
    addImg(url) {
      const addImageRange = this.quill.getSelection();
      const newRange = 0 + (addImageRange !== null ? addImageRange.index : 0);
      this.quill.insertEmbed(newRange, "image", url);
      this.quill.setSelection(1 + newRange);
    },
    showSelectImg() {
      this.$refs.choose.showDialog();
    },
  },
};
</script>
